import * as Yup from "yup"
import i18n from "../../app/i18n"

export const searchValidationSchema = (): Yup.AnyObjectSchema => {
  return Yup.object().shape({
    searchTerm: Yup.string()
      .matches(/^[a-zA-Z0-9\s-/]*$/, i18n.t("shared:searchInputValidation"))
  })
}
